export function clampProgress(rawProgress: number) {
  return Number.isFinite(rawProgress) ? Math.max(0, Math.min(rawProgress, 1)) : 0;
}
